<div class="verify-email-page">
    <div class="verify-email-container">
        <div class="verify-email-card">
            <!-- Logo Section -->
            <div class="logo-header">
                <img src="assets/images/lens-blueprint-logo.svg" alt="Lens Blueprint" class="brand-logo"
                    onerror="this.style.display='none'" />
                <h1 class="brand-title">Lens Blueprint</h1>
                <p class="brand-subtitle">Assessment Dashboard</p>
            </div>

            <!-- Content Section -->
            <div class="content-section">
                <!-- Loading State -->
                <div *ngIf="loading" class="loading-state">
                    <mat-spinner diameter="50"></mat-spinner>
                    <h2 class="content-title">Verifying your email...</h2>
                    <p class="content-description">Please wait while we verify your email address.</p>
                </div>

                <!-- Success State -->
                <div *ngIf="verified && !loading" class="success-state">
                    <div class="success-icon">
                        <mat-icon>check_circle</mat-icon>
                    </div>
                    <h2 class="content-title">Email Verified!</h2>
                    <p class="content-description">
                        Your email has been successfully verified. You can now sign in to your account.
                    </p>
                    <button mat-raised-button class="action-btn" (click)="goToLogin()">
                        <mat-icon>login</mat-icon>
                        <span>Go to Sign In</span>
                    </button>
                </div>

                <!-- Error State -->
                <div *ngIf="error && !loading" class="error-state">
                    <div class="error-icon">
                        <mat-icon>error_outline</mat-icon>
                    </div>
                    <h2 class="content-title">Verification Failed</h2>
                    <p class="content-description">{{ error }}</p>
                    <button mat-raised-button class="action-btn" (click)="goToLogin()">
                        <mat-icon>arrow_back</mat-icon>
                        <span>Back to Sign In</span>
                    </button>
                </div>
            </div>

            <!-- Footer -->
            <div class="verify-email-footer">
                <p class="copyright">&copy; {{ currentYear }} Lens Blueprint. All rights reserved.</p>
            </div>
        </div>
    </div>
</div>
